var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-helpdesk-editor"},[_c('div',{staticClass:"app-helpdesk-editor-image-area"},[_c('div',{staticClass:"editor-area"},[_c('img',{ref:"captured",attrs:{"src":_vm.imageData,"alt":"Capture screen"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }